module.exports = function getResource(label) {
    const resources = {
        emailLabel: 'Email address',
        nameLabel: 'Name',
        editLink: 'Edit'
    };

    return resources[label];
};
